let configurazione = {
    urlBackend: "https://relazioneambiente-api-test.regione.liguria.it/",
    urlApplicativo: "https://relazioni-ambiente-pub-test.regione.liguria.it/",
    token: "1e5df52a-35e7-3352-9612-604fcf8566cb",
    deployContext: "TEST PUBBLICO WSO2",
    pathRadice: "relazioneStatoAmbiente",
    tipoAmbiente: "PUB"
}

export default configurazione;